export default __webpack_public_path__ + "static/media/Eina01-Regular.2500b02c.woff2";